import { default as Company } from '.'
import { PageLoadingSupport } from '../../../common/app'
import { RouteObject } from 'react-router-dom'

const basePath = '/settings/company'
export const companyRoutes: RouteObject[] = [
  {
    path: `${basePath}/revenue-groups`,
    element: (
      <PageLoadingSupport>
        <Company.RevenueGroups.Component />
      </PageLoadingSupport>
    ),
    loader: Company.RevenueGroups.Loader,
  },
  {
    path: `${basePath}/preferences`,
    element: (
      <PageLoadingSupport>
        <Company.Preferences.Component />
      </PageLoadingSupport>
    ),
    loader: Company.Preferences.Loader,
  },
]
